export const ALERT_KINDS = ['note', 'tip', 'important', 'warning', 'caution'] as const;
export type AlertKind = (typeof ALERT_KINDS)[number];

interface HastText {
  type: 'text';
  value: string;
}

interface HastElement {
  type: 'element';
  tagName: string;
  properties: Record<string, unknown>;
  children: HastNode[];
}

type HastNode = HastText | HastElement | { type: string; children?: HastNode[] };

const MARKER = /^\s*\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\][ \t]*\n?/i;

function isElement(node: HastNode, tagName?: string): node is HastElement {
  return node.type === 'element' && (tagName === undefined || (node as HastElement).tagName === tagName);
}

function markAlert(quote: HastElement) {
  const paragraph = quote.children.find((child) => isElement(child, 'p'));
  if (!paragraph || !isElement(paragraph)) return;
  const first = paragraph.children[0];
  if (!first || first.type !== 'text') return;
  const text = first as HastText;
  const match = MARKER.exec(text.value);
  if (!match) return;
  text.value = text.value.slice(match[0].length);
  if (text.value === '') paragraph.children.shift();
  if (paragraph.children[0] && isElement(paragraph.children[0], 'br')) paragraph.children.shift();
  if (paragraph.children.length === 0) quote.children.splice(quote.children.indexOf(paragraph), 1);
  quote.properties = { ...quote.properties, dataAlert: match[1].toLowerCase() };
}

function walk(node: HastNode) {
  if (isElement(node, 'blockquote')) markAlert(node);
  if ('children' in node && node.children) for (const child of node.children) walk(child);
}

export function rehypeGfmAlerts() {
  return (tree: HastNode) => {
    walk(tree);
  };
}
